import { Route, Router } from 'react-router-dom';
import { ThemeProvider as LibraryThemeProvider } from '@aon-coverwallet/cw-react-components';
import { ApolloProvider } from '@apollo/client';
import store, { browserHistory } from 'src/redux/store';
import { Provider as ReduxProvider } from 'react-redux';
import { DatadogErrorBoundary } from 'src/utils/DatadogErrorBoundary';
import { errorHandler } from 'src/utils/datadogErrorHandler';
import { apolloClient } from './apolloClient';
import { ContextProvider } from './context';
import Routes from './routes';
import { StateProvider } from './state';
import { selectTheme } from './styled/themes/themeSelector';
import {
  themeId,
  prefixPath,
  appModeUuid,
  backendApiUrl,
} from 'src/utils/capabilities';

export const App = () => {
  const theme = selectTheme(themeId);

  return (
    <LibraryThemeProvider name={theme.name} theme={theme}>
      <DatadogErrorBoundary
        fallback={errorHandler}
        tags={{
          application_mode_uuid: appModeUuid,
          url: backendApiUrl,
        }}
      >
        <ContextProvider>
          <ReduxProvider store={store}>
            <ApolloProvider client={apolloClient}>
              <StateProvider initialState={window.config || {}}>
                <Router history={browserHistory} basename={prefixPath}>
                  <Route component={Routes} />
                </Router>
              </StateProvider>
            </ApolloProvider>
          </ReduxProvider>
        </ContextProvider>
      </DatadogErrorBoundary>
    </LibraryThemeProvider>
  );
};
